// extracted by mini-css-extract-plugin
export default {"videoOverlay":"YoutubeVideoOverlay_videoOverlay__tgkb+","closeBtn":"YoutubeVideoOverlay_closeBtn__qHrcw"};